import React, { useCallback } from 'react';
import { STEPS } from '../consts';
import { PreLoad } from './PreLoad';
import { Intro } from './Intro';
import { Dashboard } from './Dashboard';
import { SetupBucket } from './SetupBucket';
import { BucketMoneyMovement } from './BucketMoneyMovement';
import { BucketTransactions } from './BucketTransactions';

interface IProps {
    step: string;
}

export const StepSwitch = ({ step }: IProps) => {
  const activeStep = useCallback(() => {
    switch (step) {
      case STEPS.PRE_LOAD:
        return <PreLoad />;
      case STEPS.INTRO:
        return <Intro />;
      case STEPS.DASHBOARD:
        return <Dashboard />;
      case STEPS.SETUP:
        return <SetupBucket />;
      case STEPS.MONEY_MOVEMENT:
        return <BucketMoneyMovement />;
      case STEPS.TRANSACTIONS:
        return <BucketTransactions />;
      default:
        return <div>Service Unavailable.</div>;
    }
  }, [step]);
  return activeStep();
};
